<template>
  <div>
    <div v-if="keberadaan">
      Keberadaan :
      <b-badge :variant="dataKeberadaan[keberadaan].variantColor">
        {{ dataKeberadaan[keberadaan].label }}
      </b-badge>
      <br>
    </div>
    <div v-if="biayaBeban">
      Biaya/Beban :
      <b-badge :variant="dataBiayaBeban[biayaBeban].variantColor">
        {{ dataBiayaBeban[biayaBeban].label }}
      </b-badge>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    keberadaan: { type: String, default: '' },
    biayaBeban: { type: String, default: '' },
  },
  data() {
    return {
      dataKeberadaan: [
        { label: 'Tidak Ada', variantColor: 'light-secondary' },
        { label: 'Ada', variantColor: 'light-success' },
      ],
      dataBiayaBeban: [
        { label: 'Bukan', variantColor: 'light-secondary' },
        { label: 'Iya', variantColor: 'light-success' },
      ],
    }
  },
}
</script>
